module.exports = __webpack_public_path__ + "static/otp-d61c09d4ca420fa496906b04dc4354e2.jpg";